import portugueseMessages from 'ra-language-portuguese';

const customPortugueseMessages = {
  ...portugueseMessages,
  ra: {
    ...portugueseMessages.ra,
    action: {
      ...portugueseMessages.ra.action,
      toggle_theme: 'Alternar tema',
    },
    navigation: {
      ...portugueseMessages.ra.navigation,
      toggle_menu: 'Alternar menu',
      open_menu: 'Abrir menu',
      close_menu: 'Fechar menu',
    },
  },
};

export default customPortugueseMessages;
